import ReactDOM from "react-dom";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import "semantic-ui-css/semantic.min.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import configureStore from "./store/configureStore";
import { Provider } from "react-redux";
import { Login } from "./containers/Login/Login";
import { PrivateRoute } from "./containers/Login/PrivateRoute";
import { ForgotPassword } from "./containers/ForgotPassword/ForgotPassword";
import { ResetPassword } from "./containers/ResetPassword/ResetPassword";
import { SetToastMessage, ShowToastMessage, HideToastMessage } from "./actions/toastMessageActions";
import ConnectedIntlProvider from "./ConnectedIntlProvider";

const store = configureStore();

export const toast = (text: string, success: boolean, timeout: number = 5000) => {
    const dispatch = store.dispatch;
    dispatch(SetToastMessage(text, success));
    dispatch(ShowToastMessage());
    setTimeout(() => dispatch(HideToastMessage()), timeout);
};

ReactDOM.render(
    <Provider store={store}>
        <ConnectedIntlProvider>
            <Router>
                <Switch>
                    <Route exact={true} path="/login" component={Login} />
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route path="/reset-password" component={ResetPassword} />
                    <PrivateRoute exact={true} path="/" component={App} />
                    <PrivateRoute component={App} />
                </Switch>
            </Router>
        </ConnectedIntlProvider>
    </Provider>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
